import React from "react";
import { inRange, maxLength, required } from "forms/validators/validators";
import { ReduxControls } from "rhombus-react";
import { ColorInput } from "routes/qrcodes/qr_design/CustomInputs/ColorInput";
import { FileInputWithBrowse } from "routes/qrcodes/qr_design/CustomInputs/FileInputWithBrowse";
import { QrFormSection } from "routes/qrcodes/qr_design/QrFormSection";
import { MEGA } from "utils/common";
import { filesize } from "widgets/forms/validators/Assets";


const MAX_LENGTH_DESIGN_NAME = 1024;
const MAX_LOGO_MB = 7;
const MAX_LOGO_BYTES = MAX_LOGO_MB * MEGA;
const SHAPE_OPTIONS = [
	{
		value: "square",
		label: "Square",
	},
	{
		value: "circle",
		label: "Circle",
	},
];

const formFields = [
	{
		name: "name",
		type: "text",
		label: "Design Name",
		placeholder: "Enter name...",
		component: ReduxControls.Input,
		validate: [required, maxLength(MAX_LENGTH_DESIGN_NAME)],
		charMax: MAX_LENGTH_DESIGN_NAME,
		showCharCount: true,
		required: true,
		className: "xl-input",
	},
	{
		name: "details.shape",
		type: "select",
		label: "QR Shape",
		placeholder: "Select a shape...",
		isClearable: false,
		component: ReduxControls.Select,
		onMenuScrollToBottom: () => {},
		validate: [required],
		required: true,
		options: SHAPE_OPTIONS,
		normalize: (option) => {return option.value;},
		format: value => (SHAPE_OPTIONS.find(option => option.value === value)),
		className: "sm-input",
	},
	{
		name: "details.stroke.width",
		type: "number",
		label: "Stroke",
		component: ReduxControls.Input,
		validate: [required, inRange({ min: 0, max: 35 })],
		min: 0,
		max: 35,
		step: 1,
		className: "xs-input",
		format: value => value?.toString(),
		normalize: value => parseFloat(value),
	},
	{
		name: "details.stroke.color",
		type: "color",
		label: "Stroke Color",
		component: ColorInput,
		validate: [required],
		required: true,
		className: "xs-input",
	},
	{
		name: "logo",
		label: "Logo",
		//TODO: Change with FileImport once it handles correctly Redux's state in Rhombus v3.
		component: FileInputWithBrowse,
		required: false,
		accept: "image/*",
		className: "sm-input",
		removeDataTip: "Remove logo",
		validate: [filesize({ max: MAX_LOGO_BYTES })],
		maxSize: MAX_LOGO_BYTES,
	},
	{
		name: "details.imageOptions.imageSize",
		type: "number",
		label: "Logo Size",
		component: ReduxControls.Input,
		validate: [required, inRange({ min: 0, max: 0.5 })],
		min: 0,
		max: 0.5,
		step: 0.1,
		className: "xs-input",
		format: value => value?.toString(),
		normalize: value => parseFloat(value),
	},
	{
		name: "details.imageOptions.margin",
		type: "number",
		label: "Logo Margin",
		component: ReduxControls.Input,
		validate: [required, inRange({ min: 0, max: 100 })],
		min: 0,
		max: 100,
		step: 1,
		className: "xs-input",
		format: value => value?.toString(),
		normalize: value => parseFloat(value) || 0,
	},
	{
		name: "details.margin",
		type: "number",
		label: "Outer Margin",
		component: ReduxControls.Input,
		validate: [required, inRange({ min: 0, max: 100 })],
		min: 0,
		max: 100,
		step: 1,
		className: "xs-input",
		format: value => value?.toString(),
		normalize: value => parseFloat(value) || 0,
	},
	{
		name: "details.backgroundOptions.color",
		type: "color",
		label: "Background Color",
		component: ColorInput,
		validate: [required],
		required: true,
		className: "xs-input",
	},
];

export let QrCodeDetailsSection = (props) => {
	return (
		<QrFormSection
			formFields={formFields}
			formTitle={"QR Code Details"}
			readOnly={props.readonly}
		/>
	);
};

QrCodeDetailsSection.displayName = "QrCodeDetailsSection";
